export const services = [
  {
    slug: 'groups-fits',
    title: { en: 'Groups & FITs' },
    subtitle: 'Precision at scale. Personalization without compromise.',
    description: { en: 'Seamless itineraries tailored to each market.' },
    image: '/groupservices.jpeg',
  },
  {
    slug: 'incentives-corporate',
    title: { en: 'Incentives & Corporate Events' },
    subtitle: 'Strategy meets experience.',
    description: { en: 'High-level programs that inspire and reward.' },
    image: '/IncentivesCorporate.jpeg',
  },
  {
    slug: 'religious-cultural',
    title: { en: 'Religious & Cultural Tourism' },
    subtitle: 'Journeys that connect past and present.',
    description: { en: 'Meaningful journeys rooted in history and tradition.' },
    image: '/meteora.jpg',
  },
  {
    slug: 'cruises-shore',
    title: { en: 'Cruises & Shore Excursions' },
    subtitle: 'Scale executed with precision.',
    description: { en: 'Exclusive allotments and curated experiences.' },
    image: '/cruise.jpeg',
  },
  {
    slug: 'cultural-thematic',
    title: { en: 'Cultural & Thematic Tourism' },
    subtitle: 'Experiences designed around passions, knowledge, and discovery.',
    description: { en: 'Specialized thematic journeys exploring Greece through its culture and living heritage.' },
    image: '/religious.jpeg',
  },
  {
    slug: 'sports-tourism',
    title: { en: 'Sports Tourism Management' },
    subtitle: 'Precision logistics for high-performance teams.',
    description: { en: 'Expert travel and operational logistics for professional sports clubs.' },
    image: '/kalimarmaro.jpg',
  },
  {
    slug: 'vip-luxury',
    title: { en: 'VIP & Luxury Services' },
    subtitle: 'Discretion without compromise.',
    description: { en: 'Discreet, personalized care for the most demanding guests.' },
    image: '/vip.jpeg',
  },
];
